import doc                   from '@widesk-core/decorators/doc';
import AbstractLanguageModel from './AbstractLanguageModel';
import model                 from '@widesk-core/decorators/model';

@doc.urnResource('language')
@model.cacheDuration()
export default class LanguageModel extends AbstractLanguageModel {}
